module.exports = __webpack_public_path__ + "img/sessions.d4147506.png";